import { shoeConventionForSite } from "@config/site/site-config";
import { SizeLocales } from "@lib/constants/filtersConstants";
import type { StoreDataType } from "./types";
import allPagePaths from "../../scripts/contentful/page-paths.json";

export const initialState: StoreDataType = {
    isLocked: false,
    isPreviewMode: false,
    hasFreshData: false,
    me: {
        customer: null,
        globalShoeSizeConvention: shoeConventionForSite?.[0] ?? SizeLocales.EU,
        cartInfo: {
            cart: undefined,
            masterProducts: undefined,
            shippingMethods: undefined,
            isExecuted: true,
        },
        wishlistInfo: { wishlist: undefined, masterProducts: undefined, isExecuted: true },
    },
    tracking: {
        utm: {
            source: "",
            medium: "",
            campaign: "",
            term: "",
            content: "",
        },
    },
    stores: [],
    draftPromoCode: null,
    products: {
        list: [],
        currentFilters: [],
        resultsCount: null,
        initialFilters: {},
        lastVisitedPlp: null,
        lastLoadedPage: 1,
        lastVisitedPlpContainerHeight: 0,
    },
    pdpState: {
        activeProduct: null,
        isOpenAddedToBagModal: false,
    },
    storeData: null,
    parcelShopData: null,
    policyAccepted: false,
    tempCustomerData: {
        firstName: null,
        lastName: null,
    },
    pagePathData: allPagePaths,
    productImageGallery: {
        isGalleryOpen: false,
        galleryImageIndex: 0,
    },
    hasActiveTimer: false,
};
